import { render } from "./Maintwo.vue?vue&type=template&id=0cc52cba&scoped=true"
import script from "./Maintwo.vue?vue&type=script&lang=js"
export * from "./Maintwo.vue?vue&type=script&lang=js"

import "./Maintwo.vue?vue&type=style&index=0&id=0cc52cba&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc52cba"]])

export default __exports__